<div *ngIf="resource" class="h-full flex flex-col flex-1 timer-grid-wrapper relative p-2">
  <dx-button  *ngIf="userHaveTimer" style="position: absolute; opacity: 0;" class=" top-1 left-0 w-10 h-10  z-10" (onClick)="alert2TimersUser()"></dx-button >
  <div *ngIf="workers.length > 0 && isAdmin" class="workers-lookup flex grid-configuration-lookup w-[320px]" style="position: absolute; top: 19px; right: 261px; z-index: 10; height: 37px;">
    <dx-lookup class="w-full"  (valueChange)="setWorkerId($event)" [value]="workerId" [dataSource]="workers" valueExpr="id"  displayExpr="name"></dx-lookup>
  </div>
  <dx-data-grid (onRowInserted)="onDataSourceChange($event)" (onRowRemoved)="onDataSourceChange($event)" [disabledAdd]="!isAdmin && !workerId" [filterValue]="workerId ? [ 'workerId', '=', workerId ] : []"   [customParams]="{workerId: workerId, dataSource: dataSourceItems}" [createComponent]="createTimer" [glamResource]="resource!" #grid>
    <dxi-column dataField="workerId" [visible]="false"></dxi-column>
    <dxi-column cellTemplate="linkToProductionOrder" [allowEditing]="false" dataField="productionOrderCode" [caption]="'entity.timeTicket.productionOrderId' | translate"></dxi-column>
    <dxi-column cellTemplate="linkToProductionOrder" [allowEditing]="false" dataField="productionOrderTitle" [caption]="'entity.timeTicket.orderSubject' | translate"></dxi-column>
    <div *dxTemplate="let item of 'linkToProductionOrder'">
      <a (click)="navigateToProductionOrderEditor(item.data)" class="link-cell cursor-pointer">{{ item.value }}</a>
    </div>
    <dxi-column [allowEditing]="false" dataField="productionOrderOperationName" [caption]="'entity.timeTicket.productionOrderOperationId' | translate | ucfirst">
    </dxi-column>
    <dxi-column cellTemplate="linkToOrganizarion" [allowEditing]="false" dataField="organizationLegalName" [caption]="'entity.timeTicket.companyId' | translate | ucfirst">
      <div *dxTemplate="let item of 'linkToOrganizarion'">
        <a (click)="navigateToOrganitzationEditor(item.data)" class="link-cell cursor-pointer">{{ item.value }}</a>
      </div>
    </dxi-column>
    <dxi-column [allowEditing]="false" dataField="workerName" [caption]="'entity.timeTicket.workerId' | translate | ucfirst"></dxi-column>
    <dxi-column [allowEditing]="false" cellTemplate="startDate" dataField="startDate" [caption]="'entity.timeTicket.startDate' | translate | ucfirst" >
      <div *dxTemplate="let item of 'startDate'">
        {{ item.data.startDate | date: 'dd/MM/yyyy HH:mm' }}
      </div>
    </dxi-column>
    <dxi-column cellTemplate="totalTime" [allowEditing]="false" dataField="currentTime" [caption]="'entity.timeTicket.totalTime' | translate | ucfirst"></dxi-column>
    <div *dxTemplate="let item of 'totalTime'">
      <div>{{ item.data.currentTime | async }}</div>
    </div>
    <dxi-column [allowEditing]="false" cellTemplate="buttons">
      <div *dxTemplate="let item of 'buttons'">
        <dx-drop-down-button
          stylingMode="text"
          [showArrowIcon]="false"
          [dropDownOptions]="{ width: 160 }"
          [icon]="'more_vert'">

          <dxi-item>
            <ng-template dxTemplate="item">
              <div title="{{ 'common.stopTimer' | translate | ucfirst }}"
                   class="icon-item"
                   style="display: flex; align-items: center; gap: 4px"
                   (click)="stopTimer(item.data)">
                <i class="material-icons">stop</i>
                {{"common.stop" | translate | ucfirst }}
              </div>
            </ng-template>
          </dxi-item>

          <dxi-item>
            <ng-template dxTemplate="item">
              <div title="{{ 'common.deleteTimerConfirmation' | translate | ucfirst }}"
                   class="icon-item"
                   style="display: flex; align-items: center; gap: 4px"
                   (click)="deleteTimer(item.data)">
                <i class="material-icons">delete</i>
                {{"common.delete" | translate | ucfirst }}
              </div>
            </ng-template>
          </dxi-item>

        </dx-drop-down-button>
      </div>
    </dxi-column>




  </dx-data-grid>
</div>
<dx-popup
[visible]="stopTimerPopupVisible"
  [title]="('common.stopTimerTitle' | translate | ucfirst) + ' ' + stopTimmerTitleTime"
  [showTitle]="true" [showCloseButton]="true"
  [height]="'360px'"  width="420px"
  (onHidden)="stopTimerPopupVisible = false">
  <div *ngIf="form && stopTimerPopupVisible" class="flex justify-between flex-col h-full">
    <div class="flex flex-col">
      <div class="mb-3">{{'common.pendingTime' | translate | ucfirst}}</div>
      <form [formGroup]="form">
         <gs-time-span-field
        [label]="'common.pendingTimeLabel' | translate"
        formField required formControlName="pendingTime" ></gs-time-span-field>
      </form>
    </div>
    <div class="mt-3 text-right">
      <dx-button
        [disabled]="form!.invalid"
        (onClick)="stopAndSaveTime()"
        [type]="'default'"
        [icon]="'done'"
        [text]="'common.save' | translate | ucfirst"
      ></dx-button>
    </div>
  </div>
</dx-popup>
